import { useMemo } from 'react';

import { Badge, Flex, FlexProps, StyleProps } from '@chakra-ui/react';

import { Maybe, Tag } from '../../gql/generated/graphql';

type DealTagsProps = {
  tags?: Maybe<Pick<Tag, 'id' | 'display_name' | 'color' | 'is_dashboard_visible'>[]>;
  fontSize?: StyleProps['fontSize'];
  filterDashboardVisible?: boolean;
  flexProps?: FlexProps;
};

const DealTags = ({
  tags = [],
  fontSize = 10,
  filterDashboardVisible = false,
  flexProps = {},
}: DealTagsProps) => {
  const visibleTags = useMemo(
    () => (filterDashboardVisible ? tags?.filter((tag) => tag.is_dashboard_visible) : tags),
    [filterDashboardVisible, tags],
  );

  if (!visibleTags?.length) {
    return null;
  }

  return (
    <Flex h="full" gap={1} alignItems="center" flexWrap="wrap" {...flexProps}>
      {visibleTags.map((tag) => (
        <Badge
          key={tag.id}
          rounded="md"
          textTransform="uppercase"
          bg={tag.color}
          color="white"
          fontSize={fontSize}
        >
          {tag.display_name}
        </Badge>
      ))}
    </Flex>
  );
};

export default DealTags;
